import React from "react";
import { useChatContext } from "stream-chat-react";
import { ChannelReadReceiptsProvider } from "./ChannelReadReceiptsProvider";

export const ActiveChannelReadReceiptsProvider = ({ channel, children }) => {
  const { channel: activeChannel } = useChatContext();
  // Match Stream's Channel: an explicit channel takes precedence, otherwise
  // use the channel selected automatically by ChannelList on first opening.
  return (
    <ChannelReadReceiptsProvider channel={channel || activeChannel}>
      {children}
    </ChannelReadReceiptsProvider>
  );
};
